import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notificationsApi } from '@/api/notifications';

/**
 * «Прочитать все» — кнопка в шапке страницы ленты у ученика и у куратора
 * (11.09.2026).
 *
 * Отдельным файлом, а не рядом с `NotificationFeed`: файл компонента, который
 * заодно экспортирует хук, ломает горячую перезагрузку, и линтер это считает
 * предупреждением (порог зафиксирован).
 *
 * Сбрасывает ключ `['notifications']` целиком: под ним и список, и цифра
 * непрочитанных в меню куратора.
 */
export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: notificationsApi.markAllRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
